<template>
    <div class="list-loading">
        <div class="simple-loader" :style="spinnerStyle" aria-hidden="true"></div>
        <div v-if="text" role="alert">{{text}}</div>
    </div>
</template>

<script setup lang="ts">
    import {onMounted, onUnmounted, defineProps, getCurrentInstance} from 'vue';

    const props = defineProps<{
        text?: string;
        spinnerStyle?: Record<string, any>;
    }>();

    const text         = props.text ?? 'Lädt...';
    const spinnerStyle = props.spinnerStyle ?? {};

    const instance = getCurrentInstance();

    onMounted(() =>
    {
        const parentEl = instance?.proxy?.$parent?.$el;
        if (parentEl?.setAttribute)
        {
            parentEl.setAttribute('aria-live', 'polite');
            parentEl.setAttribute('aria-busy', 'true');
        }
    });

    onUnmounted(() =>
    {
        const parentEl = instance?.proxy?.$parent?.$el;
        if (!parentEl?.setAttribute)
        {
            return;
        }

        parentEl.setAttribute('aria-busy', 'false');

        window.setTimeout(() =>
        {
            parentEl.removeAttribute('aria-busy');
            parentEl.removeAttribute('aria-live');
        }, 1000);
    });
</script>
